<template>
  <v-row no-gutters>
    <v-col cols="auto">
      <base-rounded-button color="third" icon="mdi-layers" @click="isLegendVisible = true" shadow />
    </v-col>
  </v-row>
</template>
<script>
import { sync } from 'vuex-pathify';
import BaseRoundedButton from '@/components/shared/buttons/BaseRoundedButton';
export default {
  name: 'TheMobileMapButtons',
  components: { BaseRoundedButton },
  computed: {
    isLegendVisible: sync('tools/isLegendVisible'),
  },
};
</script>
